module.exports = __webpack_public_path__ + "media/images/particulier-faf04bc0617217ef15007d4d39a66b84.jpg";